import React, { useEffect, useState } from "react";
import "../styles/Users.scss";
import { useNavigate } from "react-router-dom";
import { createUser, getUsersByRoleId } from "../services/api";
import Swal from "sweetalert2";
import Select from "react-select";

function CreateUser() {
  // To display in usertypes
  const userTypes = [
    { id: 3, value: "Hiring Manager", label: "Hiring Manager" },
    { id: 4, value: "Recruiter", label: "Recruiter" },
  ];

  const isValidDateFormat = (value) => /^\d{2}-\d{2}-\d{4}$/.test(value);

  const isRealDate = (ddmmyyyy) => {
    const [dd, mm, yyyy] = ddmmyyyy.split("-").map(Number);
    const date = new Date(`${yyyy}-${mm}-${dd}`);
    return (
      date.getDate() === dd &&
      date.getMonth() + 1 === mm &&
      date.getFullYear() === yyyy
    );
  };

  const ddmmyyyyToYyyymmdd = (ddmmyyyy) => {
    const [dd, mm, yyyy] = ddmmyyyy.split("-");
    return `${yyyy}-${mm}-${dd}`;
  };

  // For integration - fields
  const [form, setForm] = useState({
    name: "",
    email: "",
    mobile: "",
    doj: "",
    notes: "",
    reportingManager: "",
    role_id: 4,
  });

  const handleDateChange = (e) => {
    const value = e.target.value;
    setForm((prev) => ({ ...prev, doj: value }));

    if (!isValidDateFormat(value)) {
      setError("Date must be in dd-mm-yyyy format");
    } else if (!isRealDate(value)) {
      setError("Invalid calendar date");
    } else {
      setError(""); // valid input
    }
  };

  const created_by = localStorage.getItem("created_by");
  const [error, setError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [managerOptions, setManagerOptions] = useState([]);
  const navigate = useNavigate();

  // For usertype change
  const handleUserTypeChange = (selected) => {
    setForm((f) => ({ ...f, role_id: selected ? selected.id : "" }));
  };

  // For Reporting manager
  const handleManagerChange = (selected) => {
    setForm((f) => ({
      ...f,
      reportingManager: selected ? selected.value : "",
    }));
  };

  // Fetch HR users (role_id 3) for reporting manager dropdown
  // This applies when creating a user who needs to report to an HR/Hiring Manager
  useEffect(() => {
    const fetchHRUsers = async () => {
      try {
        const res = await getUsersByRoleId(3); // Fetch role_id 3 users (HR/Hiring Managers)
        if (res && res.status === "S" && Array.isArray(res.result_info)) {
          setManagerOptions(
            res.result_info.map((mgr) => ({
              value: mgr.id,
              label: mgr.name + (mgr.email ? ` (${mgr.email})` : ""),
            }))
          );
        } else {
          setManagerOptions([]);
        }
      } catch (error) {
        console.error("Error fetching HR users:", error);
        setManagerOptions([]);
      }
    };

    // Always fetch HR users for the reporting manager dropdown
    fetchHRUsers();
  }, []);

  const handleSubmit = async () => {
    let emalval = new RegExp(
      "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z]{2,4}$"
    );
    if (!form.name) {
      Swal.fire({
        title: 'Missing Name',
        text: "Please provide name!",
        icon: "warning",
        
      });
    } else if (form.name.length > 75) {
      Swal.fire({
        title: 'Invalid Length',
        text: "Name should be less than 75 characters",
        icon: "warning",
        
      });
    } else if (!form.email) {
      Swal.fire({
        title: 'Missing Email',
        text: "Please enter Email",
        icon: "warning",
        
      });
    } else if (form.email && !emalval.test(form.email)) {
      Swal.fire({
        title: 'Invalid Email',
        text: "Please enter valid Email",
        icon: "warning",
        
      });
    } else if (!form.mobile) {
      Swal.fire({
        title: 'Missing Mobile Number',
        text: "Please enter Mobile Number",
        icon: "warning",
        
      });
    
    } else if (form.mobile.length < 10) {
      Swal.fire({
        title: 'Invalid Mobile Number',
        text: "Please enter a valid mobile number",
        icon: "warning",
      });
    }
    // else if (!form.doj) {
    //     Swal.fire({
    //         text: "Please select date of joining",
    //         icon: "warning",
    //         showConfirmButton: false,
    //         heightAuto: false,
    //         timer: 1500,
    //     });
    // }
    else if (!form.role_id) {
      Swal.fire({
        title: 'Missing User Type',
        text: "Please select usetype",
        icon: "warning",
      });
    } else if (form.role_id === 4 && !form.reportingManager) {
      Swal.fire({
        title: 'Missing Reporting Manager',
        text: "Please select reporting manager",
        icon: "warning",
      });
    } else {
      const payload = {
        name: form.name.trim(),
        email: form.email.trim().toLowerCase(),
        mobile: form.mobile.trim(),
        role_id: form.role_id,
        reporting_manager_user_id:
          form.role_id === 4 ? form.reportingManager : 1,
        created_by: created_by,
        doj: form.doj,
        notes: form.notes.trim(),
      };
      Swal.fire({
        html: `<img src=${require("../assets/loader.gif")} style="width: 50px" alt="loader">`,
        showConfirmButton: false,
        heightAuto: false,
        customClass: { popup: "loader-swal" },
        allowOutsideClick: false,
      });
      let apiData = await createUser({ ...payload });
      Swal.close();
      console.log(apiData);
      if (apiData.status === "S") {
        Swal.fire({
          text: "User created successfully",
          showConfirmButton: false,
          icon: "success",
          timer: 3000,
        }).then(() => {
          navigate("/users");
        });
      }
      // if (apiData.status === "E" && apiData.status_code === "300") {
      //     Swal.fire({
      //     text: "Email is already taken",
      //     showConfirmButton: false,
      //     icon: "warning",
      //     timer: 3000,
      //     });
      // }
      // if (apiData.status === "E" && apiData.status_code === "302") {
      //     Swal.fire({
      //     text: "License limit exceeded!",
      //     showConfirmButton: false,
      //     icon: "warning",
      //     timer: 3000,
      //     });
      // }
      else if (apiData.status === "E") {
        Swal.fire({
          text: apiData.message,
          showConfirmButton: false,
          icon: "warning",
          timer: 3000,
        });
      }
      if (
        apiData.status === "F" &&
        apiData.message === "Unauthorized - Missing token"
      ) {
        Swal.fire({
          text: "Please login with your credentials",
          icon: "warning",
          showConfirmButton: false,
          timer: 3000,
        }).then(() => {
          localStorage.clear();
          navigate("/login");
        });
      }
      if (
        apiData.status === "F" &&
        apiData.message === "Unauthorized - Invalid token"
      ) {
        Swal.fire({
          text: "Please login with your credentials",
          icon: "warning",
          showConfirmButton: false,
          timer: 3000,
        }).then(() => {
          localStorage.clear();
          navigate("/login");
        });
      }
    }
  };

  return (
    <div className="users-page">
      <div className="user-create-container">
        <h2 style={{ fontWeight: 600, fontSize: "1.3rem" }}>Create User</h2>
        <div className="user-create-form">
          <div className="user-section">
            <div className="user-section-title">User Details</div>
            <div className="user-row">
              <div className="user-field" style={{ minWidth: 0 }}>
                <label>Name *</label>
                <input
                  name="name"
                  value={form.name}
                  onChange={(ev) => {
                    const value = ev.target.value;
                    // Don't allow if it doesn't start with a letter (but allow empty string)
                    if (value !== "" && !/^[a-zA-Z]/.test(value)) {
                      return; // Reject if doesn't start with letter
                    }
                    // Prevent consecutive spaces
                    if (/\s{2,}/.test(value)) {
                      return; // Reject if two or more spaces occur consecutively
                    }
                    const invalidPattern =
                      /<script*?>*?<\/script>|[<>\\{0-9}=:/""'']/i;
                    if (!invalidPattern.test(value)) {
                      setForm({ ...form, name: value });
                    }
                  }}
                  maxLength={75}
                  // 
                  required
                  placeholder="Enter full name"
                  className="custom-placeholder"
                  autoComplete="off"
                />
              </div>
              <div className="user-field" style={{ minWidth: 0 }}>
                <label htmlFor="email">Email *</label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={form.email}
                  onChange={(ev) => {
                    const value = ev.target.value;
                    const emailPattern =
                      /^[a-zA-Z0-9._%+-]+(@[a-zA-Z0-9.-]*)?$/;
                    if (value && emailPattern.test(value)) {
                      setForm({ ...form, email: value });
                    } else if (!value) {
                      setForm({ ...form, email: "" });
                    }
                    // UpwardIQ restriction logic
                    if (
                      !value
                        .toLowerCase()
                        .endsWith["@upwardiq.com, @impaxivesolutions.com"]
                    ) {
                      setEmailError(
                        "Only upwardiq emails are allowed (must end with @upwardiq.com)."
                      );
                    } else {
                      setEmailError("");
                    }
                  }}
                  onBlur={(ev) => {
                    setEmailError("");
                  }}
                  
                  maxLength={75}
                  required
                  placeholder="Enter company email address"
                  className="custom-placeholder"
                  autoComplete="off"
                  title="Gmail addresses are not allowed. Please use your company email."
                />
                {emailError && (
                  <div
                    style={{
                      color: "#e53e3e",
                      fontSize: "0.95em",
                      marginTop: 2,
                    }}
                  >
                    {emailError}
                  </div>
                )}
              </div>
            </div>
            <div className="user-row">
              <div className="user-field" style={{ minWidth: 0 }}>
                <label>Mobile *</label>
                <input
                  name="mobile"
                  value={form.mobile}
                  // onChange={(ev) => {
                  //   const value = ev.target.value;
                  //   const mobilePattern =
                  //     /^\d{10}$/;
                  //   if (value && mobilePattern.test(value)) {
                  //     setForm({ ...form, mobile: value });
                  //   } else if (!value) {
                  //     setForm({ ...form, mobile: "" });
                  //   }
                  // }}
                  onChange={(ev) => {
                    const value = ev.target.value;
                    
                    // Allow only digits and limit to 10 characters max
                    if (/^\d{0,10}$/.test(value)) {
                      setForm({ ...form, mobile: value });
                    }
                  }}
                  maxLength={10}
                 
                  placeholder="Enter mobile number"
                  className="custom-placeholder"
                  autoComplete="off"
                />
              </div>
              <div className="user-field" style={{ minWidth: 0 }}>
                <label>Date of Joining</label>
                {/* <input
                        name="doj"
                        type="date"
                        value={form.doj}
                          
                        onChange={(ev) => {
                          const value = ev.target.value;
                          const isValid = /^\d{2}-\d{2}-\d{4}$/.test(value);
                          if (isValid) {
                            setForm({ ...form, doj: value });
                          }
                        }}
                        className="custom-date-input"
                        autoComplete='off'
                    /> */}
                <input
                  type="date"
                  value={form.doj}
                  onChange={(e) => setForm({ ...form, doj: e.target.value })}
                  className="custom-date-input"
                />
                {/* <input
                        name="doj"
                        type="text"
                        value={form.doj}
                        onChange={handleDateChange}
                        placeholder="dd-mm-yyyy"
                        className="custom-date-input"
                        autoComplete="off"
                        style={{
                          padding: "8px",
                          border: error ? "1px solid red" : "1px solid #ccc",
                          borderRadius: "4px",
                          width: "100%",
                          marginTop: "4px",
                        }}
                      /> */}
              </div>
            </div>
            <div className="user-row">
              <div className="user-field" style={{ minWidth: 0 }}>
                <label>User Type *</label>
                <Select
                  name="userType"
                  value={
                    userTypes.find((opt) => opt.id === form.role_id) || null
                  }
                  onChange={handleUserTypeChange}
                  options={userTypes}
                  placeholder="Select user type"
                  isSearchable={true}
                  isClearable={false}
                  classNamePrefix="react-select"
                />
              </div>
              {/* Show reporting manager dropdown if userType is Recruiter  */}
              {form.role_id === 4 ? (
                <div className="user-field" style={{ minWidth: 0 }}>
                  <label>Reporting Manager *</label>
                  <Select
                    name="reportingManager"
                    value={
                      managerOptions.find(
                        (opt) => opt.value === form.reportingManager
                      ) || null
                    }
                    onChange={handleManagerChange}
                    options={managerOptions}
                    placeholder="Select Reporting Manager"
                    isSearchable={true}
                    isClearable
                    classNamePrefix="react-select"
                    autoComplete="off"
                  />
                </div>
              ) : (
                <div
                  className="user-field"
                  style={{ minWidth: 0, visibility: "hidden" }}
                >
                  <label style={{ visibility: "hidden" }}>Spacer</label>
                  <input
                    style={{ visibility: "hidden" }}
                    tabIndex={-1}
                    readOnly
                  />
                </div>
              )}
            </div>
          </div>
          <div className="user-section">
            <div className="user-section-title">Additional Notes</div>
            <textarea
              className="user-notes custom-placeholder"
              name="notes"
              value={form.notes}
              onChange={(ev) => {
                const value = ev.target.value;
                const invalidPattern =
                  /<script.*?>.*?<\/script>|[<>\\{}=:/""'']/i;
                if (!invalidPattern.test(value)) {
                  setForm({ ...form, notes: value });
                }
              }}
              
              placeholder="Add any additional notes about the user"
              rows="2"
              autoComplete="off"
            />
          </div>
          {error && (
            <div
              style={{ color: "#e53e3e", marginBottom: 10, fontWeight: 500 }}
            >
              {error}
            </div>
          )}
          <div className="user-actions justify-content-center">
            <button
              className="cancel-btn"
              type="button"
              onClick={() => navigate("/users")}
            >
              Cancel
            </button>
            <button className="save-btn" onClick={handleSubmit}>
              Create
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreateUser;
